import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import { AGENT_HELP_ADDRESS } from "@consts/index";
import { useAccessPattern } from "@hooks/useAccessPattern";
import { PolicyWithAgencyDataFragment } from "@covertree/agent-portal-graphql";

import {
  AdditionalInsured,
  AgencyInformation,
  CancellationDetails,
  CommissionablePartner,
  Discounts,
  Financials,
  PolicyDetails,
  PolicyNotes,
  TermsAcceptance,
  UnitDetails,
} from "./OverviewSections";
import { PolicyDetailsContentProps } from "../../types";

export function Overview({
  policy,
  loading,
  error,
}: PolicyDetailsContentProps) {
  const { canSeeCommissionablePartners } = useAccessPattern();
  if (!loading && error) {
    return (
      <Box>
        <Typography variant="subtitle1" color="black" textAlign="center">
          Policy was not found. Please contact us via email at{" "}
          <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
            {AGENT_HELP_ADDRESS}
          </Link>
          .
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      <PolicyDetails policy={policy} loading={loading} />
      <Financials policy={policy} loading={loading} />
      {policy?.cancellationCreatedDate && policy?.cancellationEffectiveDate && (
        <CancellationDetails policy={policy} />
      )}
      <TermsAcceptance policy={policy} loading={loading} />
      <UnitDetails policy={policy} loading={loading} />
      <AdditionalInsured policy={policy} loading={loading} />

      <AgencyInformation
        policy={policy as PolicyWithAgencyDataFragment}
        loading={loading}
      />

      {canSeeCommissionablePartners && (
        <CommissionablePartner
          policy={policy as PolicyWithAgencyDataFragment}
          loading={loading}
        />
      )}

      <Discounts policy={policy} loading={loading} />
      <PolicyNotes policy={policy} loading={loading} error={error} />
    </Grid>
  );
}
